var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoPreClinicalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_283_7531)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_283_7531",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 15.3269 19.3269 1 37 1C54.6731 1 69 15.3269 69 33C69 50.6731 54.6731 65 37 65C19.3269 65 5 50.6731 5 33Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 33C5 15.3269 19.3269 1 37 1C54.6731 1 69 15.3269 69 33C69 50.6731 54.6731 65 37 65C19.3269 65 5 50.6731 5 33Z",
    fill: "#F5F0FF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 33M69 33M69 33M5 33M37 1M69 33M37 65M5 33M37 65V63C20.4315 63 7 49.5685 7 33H5H3C3 51.7777 18.2223 67 37 67V65ZM69 33H67C67 49.5685 53.5685 63 37 63V65V67C55.7777 67 71 51.7777 71 33H69ZM37 1V3C53.5685 3 67 16.4315 67 33H69H71C71 14.2223 55.7777 -1 37 -1V1ZM37 1V-1C18.2223 -1 3 14.2223 3 33H5H7C7 16.4315 20.4315 3 37 3V1Z",
    fill: "#7C3AED",
    mask: "url(#path-1-inside-1_283_7531)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 23V29C38.9998 29.3355 39.0841 29.6656 39.245 29.96L44.755 40.04C44.9216 40.3446 45.0061 40.6874 45.0001 41.0345C44.9941 41.3817 44.8979 41.7213 44.7208 42.02C44.5437 42.3187 44.2919 42.5661 43.9902 42.7379C43.6885 42.9098 43.3472 43.0001 43 43H31C30.6528 43.0001 30.3115 42.9098 30.0098 42.7379C29.708 42.5661 29.4562 42.3187 29.2792 42.02C29.1021 41.7213 29.0058 41.3817 28.9998 41.0345C28.9938 40.6874 29.0783 40.3446 29.245 40.04L34.755 29.96C34.9159 29.6656 35.0001 29.3355 35 29V23",
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.453 36H42.547",
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 23H40.5",
    stroke: "#7C3AED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_283_7531",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_283_7531"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_283_7531"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_283_7531"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_283_7531",
    result: "effect2_dropShadow_283_7531"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_283_7531",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoPreClinicalIcon);
export default __webpack_public_path__ + "static/media/cdmo-Pre-clinical-icon.87a03870bf64f447b81b4adacbbe44e1.svg";
export { ForwardRef as ReactComponent };